import { OperatingStatusKey } from "@/common/enums/sharedEnums.ts";

export enum MeterType {
  electricity = "electricity",
  coldWater = "coldWater",
  hotWater = "hotWater",
  gas = "gas",
  heater = "heater",
  ac = "ac",
  fuel = "fuel",
}
export interface AggregatedObservation {
  name: number;
  value: string;
}

export interface Observation {
  number: number;
  value: string;
}

export interface UnitCondition {
  number: number;
  percentage: number;
}

export interface UnitsCondition {
  new: UnitCondition;
  good: UnitCondition;
  average: UnitCondition;
  poor: UnitCondition;
  oof: UnitCondition;
}

export interface UnitsCleanliness {
  clean: UnitCondition;
  grease: UnitCondition;
  dusty: UnitCondition;
  dirty: UnitCondition;
}

export interface Unit {
  name: string;
  color: string | null;
  status: string;
  cleanliness: string;
  operatingStatus: string | null;
  location: string | null;
  number: number;
  nature: string | null;
  observations: Observation[];
}

export interface Room {
  name: string;
  type: string;
  category: string;
  size: string | null;
  unitsCondition: UnitsCondition;
  unitsCleanliness: UnitsCleanliness;
  nbUnits: number;
}

export interface Key {
  name: string;
  type: string;
  size: string | null;
  units: Unit[];
  unitsCondition: UnitsCondition;
  unitsCleanliness: UnitsCleanliness;
  nbUnits: number;
}

export interface Equipment {
  id: string;
  units: Unit[];
}

export interface Meter {
  id: string;
  type: string;
  location: string;
  lastMeasurementDate?: string;
  operatingStatus: OperatingStatusKey;
  measurement: string;
  prm: string | null;
  serialNumber: string | null;
  unit: string;
  name: string;
}

export interface TotalCondition {
  new: UnitCondition;
  good: UnitCondition;
  average: UnitCondition;
  poor: UnitCondition;
  oof: UnitCondition;
}

export interface TotalCleanliness {
  clean: UnitCondition;
  grease: UnitCondition;
  dusty: UnitCondition;
  dirty: UnitCondition;
}

export interface ServiceReport {
  id: string;
  rooms: Room[];
  key: Key;
  equipment: Equipment;
  meters: Meter[];
  observations: AggregatedObservation[];
  totalCondition: TotalCondition;
  totalCleanliness: TotalCleanliness;
  totalRooms: number;
  totalUnits: number;
  totalGoodCondition: number;
  updatedAt: string;
  mainFile: string;
  service: {
    canDoCosting: boolean;
  };
  permissions: string[];
}
